import { cn } from "@/lib/utils";
import type { ReactNode } from "react";

type TOverlayStackProps = {
	children: ReactNode;
	className?: string;
};

export function OverlayStack({ children, className }: TOverlayStackProps) {
	return <div className={cn("relative grid [&>*]:col-start-1 [&>*]:row-start-1", className)}>{children}</div>;
}
